import {ApiResponse} from '../../app/core/_core'
import * as auth from '../reducers/authReducer'
import api from 'config/api'
import axiosConfig from '../../config/axios'
import * as authHelper from 'app/modules/auth/core/AuthHelpers'

export const AUTH_URL = '/auth'

export const login = (values: any) => (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    dispatch(auth.actions.setLoading(true))
    try {
      var authResult = (await api.auth.postAuthLogin({requestBody: {username: values.username, password: values.password}})) as unknown as ApiResponse<string>
      if (authResult.data) {
        axiosConfig
          .get('/user/profile', {
            headers: {
              Authorization: `Bearer ${authResult?.data}`,
            },
          })
          .then(async (res) => {
            if (res?.data) {
              await dispatch(auth.actions.setToken(authResult.data ?? '', null))
              await authHelper.storeUser(res?.data?.data)
              resolve(true)
            } else {
              reject(false)
            }
          })
          .catch(() => {})
      } else {
        reject(authResult.message)
      }
    } catch (error) {
      if (typeof error === 'string') {
        if (error.includes('Invalid Password')) {
          await dispatch(auth.actions.setErrorMessage('Password kamu salah!'))
        } else if (error.includes('User not found')) {
          await dispatch(auth.actions.setErrorMessage(`User ${values.username} tidak ditemukan!`))
        } else {
          await dispatch(auth.actions.setErrorMessage(error as string))
        }
      } else {
        dispatch(auth.actions.setErrorMessage('The login detail is incorrect'))
      }
      reject(false)
    }
  })
}
